import React from 'react'
import Yup from '../../../../helpers/custom-yup'
import Title from '../../../../components/typography/title.component'
import moment from 'moment'
import withRouter from 'react-router-dom/withRouter'
import Pagination from './components/pagination/pagination.component.jsx'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import StyledSectionHeader from '../../../../components/layout/styles/styled-section-header.style'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { toastActions } from '../../../../actions'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { ticketsSalesReportActions } from './tickets-sales-report.actions'
import FormComponent from './components/pagination/form.component'

const schema = Yup.object().shape({
	dateFilterType: Yup.string().required('Selecione um valor'),
	period: Yup.string().required('Selecione um período'),
	initialDate: Yup.string().required('Selecione uma data inicial'),
	finalDate: Yup.string().required('Selecione uma data final'),
	pointsStatus: Yup.string().required('Selecione uma situação'),
	ticketStatus: Yup.string().required('Selecione uma situação')
})

class TicketsSalesReportPage extends React.Component {
	constructor(props) {
		super(props)
		this.initialValues = {
			dateFilterType: 'Sale',
			period: 30,
			initialDate: moment()
				.add(-30, 'd')
				.format('DD/MM/YYYY'),
			finalDate: moment().format('DD/MM/YYYY'),
			pointsStatus: 'todos',
			ticketStatus: 'Active',
			redeemed: 'all',
			clientName: '',
			trackNumber: ''
		}
		this.state = {
			...this.initialValues,
			isExporting: false
		}

		this.formRef = React.createRef()
		this.periodRef = React.createRef()
		this.paginationRef = React.createRef()

		this.exportReport = exportReport.bind(this)
	}

	normalizeValues = values => ({
		...values,
		pointsStatus: values.pointsStatus === 'todos' ? null : values.pointsStatus
	})

	onSubmit = async values => {
		this.setState({ ...this.normalizeValues(values) }, () => {
			this.state.isExporting
				? this.props.exportData({
						dateEnd: this.state.finalDate,
						redeemed: this.state.redeemed,
						dateStart: this.state.initialDate,
						clientName: this.state.clientName,
						trackNumber: this.state.trackNumber,
						pointsStatus: this.state.pointsStatus,
						ticketStatus: this.state.ticketStatus,
						dateFilterType: this.state.dateFilterType
				  })
				: this.paginationRef.current
				? this.paginationRef.current.reload()
				: null

			this.setState({ isExporting: false })
		})
	}

	componentDidMount() {
		this.formRef.current.submitForm()
	}

	render() {
		const {
			redeemed,
			finalDate,
			clientName,
			initialDate,
			trackNumber,
			pointsStatus,
			ticketStatus,
			dateFilterType
		} = this.state

		const params = {
			redeemed,
			finalDate,
			clientName,
			initialDate,
			trackNumber,
			pointsStatus,
			ticketStatus,
			dateFilterType
		}

		return (
			<InnerPageContainer>
				<Title>Passagens vendidas</Title>
				<StyledSectionHeader>Filtros</StyledSectionHeader>
				<Formik
					ref={this.formRef}
					onSubmit={this.onSubmit}
					validationSchema={schema}
					initialValues={this.initialValues}
					render={props => (
						<FormComponent
							{...props}
							finalDate={finalDate}
							formRef={this.formRef}
							periodRef={this.periodRef}
							exportReport={this.exportReport}
						/>
					)}
				/>
				<div data-permission="858B812BB82816AD3D0986F96A1353FC35E539EB">
					<Pagination params={params} paginationRef={this.paginationRef} />
				</div>
			</InnerPageContainer>
		)
	}
}

function exportReport() {
	this.setState({ isExporting: true })
	this.formRef.current.submitForm()
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{ ...SiteCreators, ...toastActions, ...ticketsSalesReportActions },
		dispatch
	)

const connectedTicketsSalesReportPage = withRouter(
	connect(null, mapDispatchToProps)(TicketsSalesReportPage)
)

export { connectedTicketsSalesReportPage as ModuleRootComponent }
